<section class="cmn-innerpage-wrapper new-chart-accounts">
  <h2 class="cmn-inner-heading">Edit Petty Cash Activity</h2>
  <form [formGroup]="addPettyCashActivityForm">
    <label class="radio-label"
      >Select Type <span class="red">*</span></label
    >
    <!-- Format Selection -->
    <div class="type-selection">
      <label class="radiobtn-wrapper">
        <input
          type="radio"
          name="type"
          value="IN"
          formControlName="type"
        />
        <span class="radiomark"></span>
        IN
      </label>
      <label class="radiobtn-wrapper">
        <input
          type="radio"
          name="type"
          value="OUT"
          formControlName="type"
        />
        <span class="radiomark"></span>
        OUT
      </label>
    </div>

    <div class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Amount</label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter amount"
            formControlName="amount"
            (keypress)="allowOnlyNumberWithDecimal($event)"
            (paste)="blockPaste($event)"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('amount')!.touched &&
              addPettyCashActivityForm.get('amount')!.hasError('required')
            "
          >
            Amount is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">description<span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Description"
            formControlName="description"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('description')!.touched &&
              addPettyCashActivityForm.get('description')!.hasError('required')
            "
          >
            Description is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Account <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select Account</mat-label>
          <mat-select formControlName="accountId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No accounts found'"
                (input)="onSearch($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let bank of bankAccountsData"
              [value]="bank.id"
            >
              {{ bank.accountName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('accountId')?.touched &&
              addPettyCashActivityForm.get('accountId')?.hasError('required')
            "
          >
            Account is required.
          </mat-error>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="cmn-next-btn" (click)="onSave()">Save</button>
    </div>
  </form>
</section>
